import {
    CatalogItemColumn,
    CatalogItemView,
} from "@common/types/views/catalogItemViews";

interface GetGatedCatalogItemColumnsParams {
    hasClassesAccess: boolean;
    showReceivablesAccount: boolean;
}

export const getGatedCatalogItemColumns = ({
    hasClassesAccess,
    showReceivablesAccount,
}: GetGatedCatalogItemColumnsParams): CatalogItemColumn[] => [
    ...(hasClassesAccess ? [] : [CatalogItemColumn.CLASS]),
    ...(showReceivablesAccount ? [] : [CatalogItemColumn.RECEIVABLES_ACCOUNT]),
];

export const stripGatedCatalogItemColumns = (
    view: CatalogItemView,
    gatedColumnIds: CatalogItemColumn[],
): CatalogItemView => {
    if (gatedColumnIds.length === 0) {
        return view;
    }
    return {
        ...view,
        columns: view.columns.filter(
            (column) => !gatedColumnIds.includes(column.id),
        ),
    };
};

interface RestoreGatedCatalogItemColumnsParams {
    previousView: CatalogItemView;
    nextView: CatalogItemView;
    gatedColumnIds: CatalogItemColumn[];
}

export const restoreGatedCatalogItemColumns = ({
    previousView,
    nextView,
    gatedColumnIds,
}: RestoreGatedCatalogItemColumnsParams): CatalogItemView => {
    const columns = [...nextView.columns];
    previousView.columns.forEach((column, index) => {
        const isGated = gatedColumnIds.includes(column.id);
        const isAlreadyPresent = columns.some(({ id }) => id === column.id);
        if (isGated && !isAlreadyPresent) {
            columns.splice(Math.min(index, columns.length), 0, column);
        }
    });
    return { ...nextView, columns };
};
